/*
 * Frontend vanilla JavaScript entry point for VB Webinar Manager.
 *
 * Initializes lightweight public-facing browser behavior for webinar pages,
 * archives, registration forms, and non-React frontend interactions.
 *
 * @package   VBWebinarManager
 * @subpackage Scripts
 * @since     0.1.0
 * @author    VerBaste
 * @authorURL https://verbaste.com
 * @copyright 2026 VerBaste
 * @license   GPL-2.0-or-later OR Proprietary
 * @created   2026-06-09 14:45
 */

function getSessionItem( key ) {
	try {
		return window.sessionStorage.getItem( key );
	} catch ( error ) {
		return null;
	}
}

function setSessionItem( key, value ) {
	try {
		window.sessionStorage.setItem( key, value );
	} catch ( error ) {
		// Ignore storage errors.
	}
}

function updateCountdown( popout, targetTimestamp ) {
	const daysElement = popout.querySelector( '[data-vbwm-countdown-days]' );
	const hoursElement = popout.querySelector( '[data-vbwm-countdown-hours]' );
	const minutesElement = popout.querySelector( '[data-vbwm-countdown-minutes]' );
	const secondsElement = popout.querySelector( '[data-vbwm-countdown-seconds]' );

	if (
		! daysElement ||
		! hoursElement ||
		! minutesElement ||
		! secondsElement
	) {
		return false;
	}

	const now = Math.floor( Date.now() / 1000 );
	const diff = targetTimestamp - now;

	if ( diff <= 0 ) {
		popout.remove();
		return false;
	}

	const days = Math.floor( diff / 86400 );
	const hours = Math.floor( ( diff % 86400 ) / 3600 );
	const minutes = Math.floor( ( diff % 3600 ) / 60 );
	const seconds = diff % 60;

	daysElement.textContent = String( days );
	hoursElement.textContent = String( hours );
	minutesElement.textContent = String( minutes );
	secondsElement.textContent = String( seconds );

	return true;
}

document.addEventListener( 'DOMContentLoaded', () => {
	document.documentElement.classList.add( 'vbwm-frontend-js-ready' );

	const agendaItems = document.querySelectorAll(
		'.vbwm-agenda-accordion .vbwm-agenda-item'
	);
	
	agendaItems.forEach( ( agendaItem ) => {
		const agendaSummary = agendaItem.querySelector( 'summary' );
	
		agendaItem.setAttribute( 'open', '' );
	
		if ( ! agendaSummary ) {
			return;
		}
	
		agendaSummary.setAttribute( 'aria-disabled', 'true' );
		agendaSummary.setAttribute( 'tabindex', '-1' );
	
		agendaSummary.addEventListener( 'click', ( event ) => {
			event.preventDefault();
			agendaItem.setAttribute( 'open', '' );
		} );
	
		agendaSummary.addEventListener( 'keydown', ( event ) => {
			if ( 'Enter' !== event.key && ' ' !== event.key && 'Spacebar' !== event.key ) {
				return;
			}
	
			event.preventDefault();
			agendaItem.setAttribute( 'open', '' );
		} );
	} );

	const pageCountdown = document.querySelector( '[data-vbwm-webinar-countdown]' );

	if ( pageCountdown ) {
		const pageTargetTimestamp = parseInt(
			pageCountdown.getAttribute( 'data-target-timestamp' ),
			10
		) || 0;

		if ( pageTargetTimestamp > 0 ) {
			const shouldContinue = updateCountdown(
				pageCountdown,
				pageTargetTimestamp
			);

			if ( shouldContinue ) {
				const pageCountdownInterval = window.setInterval( () => {
					const pageShouldContinue = updateCountdown(
						pageCountdown,
						pageTargetTimestamp
					);

					if ( ! pageShouldContinue ) {
						window.clearInterval( pageCountdownInterval );
					}
				}, 1000 );
			}
		}
	}

	const popout = document.querySelector( '[data-vbwm-webinar-popout]' );

	if ( ! popout ) {
		return;
	}

	const storageKey = popout.getAttribute( 'data-storage-key' );
	const closeButton = popout.querySelector( '[data-vbwm-webinar-popout-close]' );
	const targetTimestamp = parseInt(
		popout.getAttribute( 'data-target-timestamp' ),
		10
	) || 0;

	if ( storageKey && '1' === getSessionItem( storageKey ) ) {
		popout.remove();
		return;
	}

	const popoutDelay = 5000;

	window.setTimeout( () => {
		if ( ! document.body.contains( popout ) ) {
			return;
		}

		popout.classList.add( 'is-visible' );
	}, popoutDelay );

	if ( targetTimestamp > 0 ) {
		const shouldContinue = updateCountdown( popout, targetTimestamp );

		if ( shouldContinue ) {
			window.setInterval( () => {
				updateCountdown( popout, targetTimestamp );
			}, 1000 );
		}
	}

	if ( ! closeButton ) {
		return;
	}

	closeButton.addEventListener( 'click', () => {
		if ( storageKey ) {
			setSessionItem( storageKey, '1' );
		}

		popout.remove();
	} );
} );
